import type { TripItineraryData } from 'tripPlanner/api/types'
import type { DrawerExperienceSearchTile } from './ExperienceListingDrawer/ExperienceDetailView'
import ExperienceSearchResults from './ExperienceListingDrawer/ExperienceSearchResults'

interface Props {
  experiences: Array<DrawerExperienceSearchTile>
  isLoading: boolean
  onSelectExperience: (experience: DrawerExperienceSearchTile) => void
  placeName: string
  browseAllResultsUrl: string
  itineraryData?: TripItineraryData
  onSendMessage?: (message: string) => void
  getTrackingOffer?: (offerId: string) => App.ExperienceOffer | undefined
}

function ThingsToDoTab({
  experiences,
  isLoading,
  onSelectExperience,
  placeName,
  browseAllResultsUrl,
  itineraryData,
  onSendMessage,
  getTrackingOffer,
}: Props) {
  return (
    <ExperienceSearchResults
      experiences={experiences}
      isLoading={isLoading}
      onSelectExperience={onSelectExperience}
      placeName={placeName}
      browseAllResultsUrl={browseAllResultsUrl}
      itineraryData={itineraryData}
      onSendMessage={onSendMessage}
      getTrackingOffer={getTrackingOffer}
    />
  )
}

export default ThingsToDoTab
